// src/TutorRegistration.js
import React from 'react';
import { Link } from 'react-router-dom';

const TutorRegistration = () => {
  const sectionStyle = {
    padding: '2rem 12px',
    backgroundColor: '#ff7c0a', // Replace with your "myprimary-color-bg"
    color: 'white',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: '1000px',
    margin: '0 auto',
    alignItems: 'center',
  };

  const imgContainerStyle = {
    width: '100%',
    maxWidth: '400px',
    flex: '1 1 50%',
    paddingBottom: '0.5rem',
    textAlign: 'center',
  };

  const imgStyle = {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
  };

  const contentContainerStyle = {
    flex: '1 1 50%',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    textAlign: 'left',
  };

  const titleStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
  };

  const paragraphStyle = {
    marginBottom: '1.5rem',
    fontSize: '1rem',
  };

  const buttonStyle = {
    backgroundColor: 'white',
    color: '#ff7c0a',
    fontWeight: 'bold',
    padding: '12px 24px',
    borderRadius: '8px',
    textDecoration: 'none',
    fontSize: '1.2rem',
    transition: 'background-color 0.3s ease',
  };

  const buttonHoverStyle = {
    backgroundColor: '#ece9e9'
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        {/* Image on the left */}
        <div style={imgContainerStyle}>
          <img
            src={`${process.env.PUBLIC_URL}/images/Frame 2.svg`} // Replace with actual image path
            alt="Register as a Tutor"
            style={imgStyle}
          />
        </div>
        {/* Text content on the right */}
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Become a Tutor</h2>
          <p style={paragraphStyle}>
            Join our platform and start teaching today. Enjoy the benefits of flexible hours, competitive pay, and
            the opportunity to make a difference in students' lives.
          </p>
          <Link
            to="/tutor-registration"
            style={buttonStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
            onMouseOut={(e) => (e.target.style.backgroundColor = 'white')}
          >
            Start Teaching Today
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TutorRegistration;